// extracted by mini-css-extract-plugin
export default {"table":"KxRgrSection_table__sNMPt","value":"KxRgrSection_value__lxxmK","underline":"KxRgrSection_underline__F+mD8","wrapper":"KxRgrSection_wrapper__ICQ69"};